import { Box, Flex, HStack, Stack } from '@chakra-ui/react';
import { Icon } from '@common/components/Icon';
import { useInboxModel } from '@common/models/InboxModel';
import support from '@common/support';
import React from 'react';
import { TextBlock } from 'src/apps/invest/common/components/TextBlock';

export const HelpCard: React.FC = () => {
  const inboxModel = useInboxModel();

  return (
    <Stack>
      <HStack gap="5px">
        <TextBlock weight="bold" fontSize="28px">
          Help
        </TextBlock>
        {inboxModel.newIntercomUnreadMessageCount > 0 && (
          <TextBlock
            fontSize={'12px'}
            weight="bold"
            color="white"
            display="inline-flex"
            backgroundColor={'gray.300'}
            width="25px"
            height="25px"
            borderRadius={'50%'}
            alignItems={'center'}
            justifyContent={'center'}>
            {inboxModel.newIntercomUnreadMessageCount}
          </TextBlock>
        )}
      </HStack>
      <Flex
        p={'24px'}
        borderWidth={'1px'}
        borderColor={'black'}
        gap={'20px'}
        justifyContent={'space-between'}
        cursor={'pointer'}
        position="relative"
        borderRadius={'10px'}
        onClick={() => support.show()}
        _hover={{
          backgroundColor: 'gray.50',
          transition: 'all 0.2s ease-in-out',
        }}>
        <Box alignItems={'center'} display="flex" justifyContent={'center'} maxWidth={'100px'}>
          <Icon color={'gray.600'} fontSize={'20px'} icon="comment" variant="regular" />
        </Box>
        <Box alignItems={'center'} display="flex" flex={1}>
          <TextBlock weight="bold" color={'black'}>
            Want to chat with us?
          </TextBlock>
        </Box>
        <Icon fontSize={'24px'} icon="chevron-right" />
      </Flex>
    </Stack>
  );
};
